import { render } from "./PoiDetail.vue?vue&type=template&id=5fdad68b"
import script from "./PoiDetail.vue?vue&type=script&lang=js"
export * from "./PoiDetail.vue?vue&type=script&lang=js"

import "./PoiDetail.vue?vue&type=style&index=0&id=5fdad68b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__